<template>
    <div v-if="atendimento">
        <div class="small text-primary mb-1">Aparelhos</div>

        <div class="form-row mb-2"> 
            <div class="col col-md-6">
                <az-periodo v-model="filtros" :sync="true" @sync="load(false)" />
            </div>

            <div class="col col-12 col-md-6">
                <az-input 
                    icon="fa fa-search fa-fw"
                    type="text"
                    placeholder="Pesquisar..."
                    v-model="filtros.pesquisa">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                            <button class="btn btn-outline-primary" type="button" @click="incluir()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados && dados.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="dados && !dados.length">
            <az-empty-state 
                :icon="firstLoad ? 'fa-solid fa-sliders-simple' : 'fas fa-sync-alt'" 
                :msg="firstLoad ? 'Nenhuma registro de aparelho encontrado.' : 'Clique no ícone para atualizar a busca.'"
                :action="firstLoad ? '' : 'Buscar'"
                :method="load"></az-empty-state>
        </div>
        
        <div v-else>
            <table class="table table-sm table-hover small">
                <thead>
                    <tr>
                        <th>Início</th>
                        <th>Fim</th>
                        <th>Duração</th>
                        <th>Responsável</th>
                        <th>Descrição</th>
                        <th>Obs</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(aparelho, ibx) in dados" :key="ibx" :class="aparelho.dt_fim ? '' : 'table-success'">
                        <td>
                            <a href="#" @click.prevent="editar(aparelho)" class="card-link text-nowrap" v-if="aparelho.dt_inicio">
                                {{ $util.getFormatDate(aparelho.dt_inicio) }}
                                {{ aparelho.dt_inicio.slice(11,16) }}
                            </a>
                        </td>
                        <td>
                            <template v-if="aparelho.dt_fim">
                                {{ $util.getFormatDate(aparelho.dt_fim) }}
                                {{ aparelho.dt_fim.slice(11,16) }}
                            </template>
                        </td>
                        <td>
                            <template v-if="aparelho.dt_fim">
                                {{ duracao_momento(aparelho.dt_inicio, aparelho.dt_fim) }}
                            </template>
                            <template v-else>
                                {{ duracao_momento(aparelho.dt_inicio, $util.hoje_com_hora()) }}
                            </template>
                        </td>
                        <td>
                            <template v-if="aparelho.usuario">{{ aparelho.usuario.st_login }}</template>
                        </td>
                        <td>
                            <template v-if="aparelho.item">{{ aparelho.item.search }}</template>
                        </td>
                        <td>
                            {{ aparelho.st_obs }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Edição -->
        <div class="modal fade" id="aparelhoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Aparelho
                            <span class="badge badge-secondary">{{ edicao.id_internacao_aparelho_historico ? '#' + edicao.id_internacao_aparelho_historico : 'Novo' }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Início"
                                    type="datetime-local"
                                    step="60"
                                    :edicao="!edicao.id_internacao_aparelho_historico"
                                    required
                                    :validate="validate"
                                    v-model="edicao.dt_inicio" />
                                <div class="small text-muted" v-if="edicao.usuario">
                                    {{ edicao.usuario.st_login }}
                                </div>
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Fim"
                                    type="datetime-local"
                                    step="60"
                                    :validate="validate"
                                    v-model="edicao.dt_fim" />
                            </div>
                        </div>
                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <az-input 
                                    v-if="!edicao.id_internacao_aparelho_historico"
                                    label="Aparelho"
                                    type="select"
                                    optionsMode="aql"
                                    service="internacao_aparelhos.index"
                                    required
                                    :validate="validate"
                                    v-model="edicao.item">
                                    <template v-slot:buttonposb v-if="edicao.item">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                #{{ edicao.item.id_internacao_aparelho }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>

                                <az-input 
                                    v-else
                                    label="Aparelho"
                                    :edicao="false"
                                    v-model="edicao.item.search">
                                    <template v-slot:buttonposb v-if="edicao.item">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                #{{ edicao.item.id_internacao_aparelho }}
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Observação"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="edicao.st_obs" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">{{ edicao.id_internacao_aparelho_historico ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from "moment";
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            filtros: {
                inicio: null,
                fim: null, 
                periodo: "h", 
                pesquisa: "", 
            },
            firstLoad: false,
            dados: [],
            edicao: null, 
            validate: false, 
        };
    },

    props: ['atendimento'], 
    
    components: {
        AzInput,
        AzPeriodo,
        AzSubmit,
    },

    methods: { 
        editar (blo) { 
            this.validate = false; 
            this.edicao = _.cloneDeep(blo);

            $('#aparelhoModal').modal('show');
        },

        duracao_momento (entrada, saida) { 
            return moment
                    .duration(moment(saida, "YYYY-MM-DD HH:mm:ss").diff(moment(entrada, "YYYY-MM-DD HH:mm:ss")))
                    .humanize();
        },

        incluir () { 
            this.validate = false; 

            this.edicao = { 
                id_internacao_aparelho_historico: null, 
                id_paciente: this.atendimento.id_paciente,
                id_internacao: this.atendimento.id_internacao,
                dt_inicio: this.$util.hoje_com_hora(),
                dt_fim: "", 
                item: "", 
                st_obs: "", 
            };

            $('#aparelhoModal').modal('show');
        },

        atualizar () { 
            if ( this.edicao && this.edicao.item && !this.edicao.id_internacao_aparelho_historico ) { 
                this.edicao.id_internacao_aparelho = this.edicao.item.id_internacao_aparelho;
            }

            this.$util.atualizar(this, { 
                service: 'internacao_aparelho_historicos', 
                func: 'store',
                dados: { 
                    ...this.edicao,
                    ...this.filtros, 
                },
                modal: 'aparelhoModal',
                toast: true, 
                callback: () => { 
                    this.load(); 
                }
            });
        },

        load() { 
            this.firstLoad = true; 

            this.$util.load(this, { 
                service: 'internacao_aparelho_historicos', 
                func: 'index',
                parms: { 
                    id_paciente: this.atendimento.id_paciente,
                    id_internacao: this.atendimento.id_internacao,
                    ...this.filtros,
                },
                loadTo: res => { 
                    this.dados = res; 
                }
            });
        },

        init() { 
            if ( !this.firstLoad ) { 
                this.load(); 
            }
        },

    }

}
</script>
